interface ProblemDetailsDtoArgs {
  type: ProblemDetailsDto['type'];
  title: ProblemDetailsDto['title'];
  status: ProblemDetailsDto['status'];
  detail: ProblemDetailsDto['detail'];
  instance: ProblemDetailsDto['instance'];
}

export default class ProblemDetailsDto {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance: string;

  constructor({ type, title, status, detail, instance }: ProblemDetailsDtoArgs) {
    this.type = type;
    this.title = title;
    this.status = status;
    this.detail = detail;
    this.instance = instance;
  }
}
